import {
	Component,
} from 'preact';

const axios = require('axios').default;

class Logo extends Component {

	veyoLogoUrl = 'https://jadzia.azureedge.net/veyobar/assets/mtm-logo.png';

	componentDidUpdate(prevProps) {
		if (prevProps.logoUrl !== this.props.logoUrl) {
			axios.get(this.props.logoUrl, { headers: { 'X-AuthToken': this.props.authToken }, responseType: 'arraybuffer' }).then((res) => {

				if (res.status === 200) {
					let data = new Uint8Array(res.data);
					let raw = String.fromCharCode.apply(null, data);
					let base64 = btoa(raw);
					let src = "data:image;base64," + base64;

					this.img.src = src;
				}
			}, (rejected) => {
				this.img.src = this.veyoLogoUrl;
			}).catch(err => {
				this.img.src = this.veyoLogoUrl;
			});
		}
	}

	render(props, state) {
		return (<div id="logo-section"><img src={this.veyoLogoUrl} alt={"Loading..."} ref={(e) => this.img = e} /></div>);
	}
}

export { Logo };



// WEBPACK FOOTER //
// ./components/sidebar/logo.js